export default [
  {
    path: '/:accountId/catalogs',
    name: 'catalogs',
    component: () => import('@/views/client/properties/catalogs/Catalogs.vue'),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Catalogs',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Catalogs',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/catalogs/create',
    name: 'create-catalogs',
    component: () => import('@/views/client/properties/catalogs/CatalogSettings.vue'),
    props: () => ({
      catalogId: '0',
    }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Catalogs.CreateCatalog',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Catalogs',
          to: '/catalogs',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.CreateCatalog',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:accountId/catalogs/:catalogId/details',
    name: 'catalog-details',
    component: () => import('@/views/client/properties/catalogs/CatalogDetails.vue'),
    props: route => ({
      catalogId: route.params.catalogId,
    }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Catalogs.CatalogDetails',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Catalogs',
          to: '/catalogs',
        },
        {
          text: '',
          to: '',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.CatalogDetails',
          active: true,
        },
      ],
    },
    beforeEnter: (to, from, next) => {
      if (from.hash.includes('#shared-catalogs')) {
        to.meta.breadcrumb[1].text = 'ClientPortal.SideMenu.Catalogs.SharedCatalogs'
        to.meta.breadcrumb[1].to = '/catalogs/#shared-catalogs'
      } else {
        to.meta.breadcrumb[1].text = 'ClientPortal.SideMenu.Catalogs.MyCatalogs'
        to.meta.breadcrumb[1].to = '/catalogs'
      }
      to.meta.pageTitle = 'ClientPortal.SideMenu.Catalogs'
      to.meta.breadcrumb[2].text = ''
      next()
    },
  },
  {
    path: '/:accountId/catalogs/:catalogId/sets/create',
    name: 'create-catalog-set',
    component: () => import('@/views/client/properties/catalogs/CreateCatalogSet.vue'),
    props: route => ({ catalogId: route.params.catalogId }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Catalogs.CatalogDetails.CreateCatalogSet',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Catalogs',
          to: '/catalogs',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.CatalogDetails',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.CatalogDetails.CreateCatalogSet',
          active: true,
        },
      ],
    },
    beforeEnter: (to, from, next) => {
      to.meta.breadcrumb[1].to = `/catalogs/${to.params.catalogId}/details#sets`
      next()
    },
  },
  {
    path: '/:accountId/catalogs/:catalogId/sets/:setId/edit',
    name: 'edit-catalog-set',
    component: () => import('@/views/client/properties/catalogs/CreateCatalogSet.vue'),
    props: route => ({ catalogId: route.params.catalogId, catalogSetId: route.params.setId }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Catalogs.EditCatalogSet',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Catalogs',
          to: '/catalogs',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.CatalogDetails',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.EditCatalogSet',
          active: true,
        },
      ],
    },
    beforeEnter: (to, from, next) => {
      to.meta.breadcrumb[1].to = `/catalogs/${to.params.catalogId}/details#sets`
      next()
    },
  },
  {
    path: '/:accountId/catalogs/:catalogId/sets/:setId/items',
    name: 'catalog-set-items',
    component: () => import('@/views/client/properties/catalogs/CatalogItems.vue'),
    props: route => ({ catalogId: route.params.catalogId, catalogSetId: route.params.setId }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Catalogs.CatalogSetItems',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Catalogs',
          to: '/catalogs',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.CatalogDetails',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.CatalogSetItems',
          active: true,
        },
      ],
    },
    beforeEnter: (to, from, next) => {
      to.meta.breadcrumb[1].to = `/catalogs/${to.params.catalogId}/details#catalog-items`
      next()
    },
  },
  {
    path: '/:accountId/catalogs/schemas/create/:catalogSchemaId?',
    name: 'create-catalog-schema',
    component: () => import('@/views/client/properties/catalogs/CreateCatalogSchema.vue'),
    props: route => ({
      catalogSchemaId: route.params.catalogSchemaId !== undefined ? parseInt(route.params.catalogSchemaId, 10) : 0,
    }),
    meta: {
      pageTitle: 'ClientPortal.SideMenu.Catalogs.CatalogSchema',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Catalogs',
          to: '/catalogs',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.CatalogSchemas',
          to: '/catalogs#catalog-schema-list',
        },
        {
          text: 'ClientPortal.SideMenu.Catalogs.CatalogSchema',
          active: true,
        },
      ],
    },
  },
]
